import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "input-group has-validation" }
const _hoisted_4 = ["id", "name", "placeholder", "type", "value", "autocomplete", "readonly"]
const _hoisted_5 = {
  key: 0,
  class: "input-group-append"
}
const _hoisted_6 = { class: "input-group-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", { for: $props.name }, _toDisplayString($props.label), 9, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: $props.name,
        class: _normalizeClass([{
          'is-invalid': !!$setup.errorMessage && $props.validationEnabled,
          'is-valid': $setup.meta.valid && $props.validationEnabled
        }, "form-control"]),
        name: $props.name,
        placeholder: $props.placeholder,
        type: $props.type,
        value: $setup.inputValue,
        autocomplete: $props.autocomplete,
        onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleBlur && $setup.handleBlur(...args))),
        onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleInputChange($event))),
        onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($props.onkeyup && $props.onkeyup(...args))),
        readonly: $props.readonly
      }, null, 42, _hoisted_4),
      ($props.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, { icon: $props.icon }, null, 8, ["icon"])
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString($setup.errorMessage), 513), [
        [_vShow, $setup.errorMessage && $props.validationEnabled]
      ]),
      _withDirectives(_createElementVNode("div", { class: "valid-feedback" }, _toDisplayString($props.successMessage), 513), [
        [_vShow, $setup.meta.valid && $props.successMessage && $props.validationEnabled]
      ])
    ])
  ]))
}